export const initVideos = () => {
	const videos: NodeListOf<HTMLVideoElement> = document.querySelectorAll('video[autoplay]');
	videos.forEach((video: HTMLVideoElement) => {
		video.play();
	});
}

